"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcessBlockInputsForBlockNumber = void 0;
const common_1 = require("@ethereumjs/common");
const ints_sequence_1 = require("../ints-sequence");
const block_1 = require("@ethereumjs/block");
const bytes_1 = require("../bytes");
const __1 = require("../..");
/**
 * Produces the input data for the process_block function in Herodotus
 * using a block number.
 * @param block Block object from RPC call
 * @param chain EVM chain identifier
 * @param hardfork Hardfork identifier
 */
const getProcessBlockInputsForBlockNumber = async (provider, blockNumber, chain = common_1.Chain.Mainnet, hardfork = common_1.Hardfork.Cancun) => {
    const providerURL = typeof provider === 'string' ? provider : provider.connection.url;
    const block = await block_1.Block.fromJsonRpcProvider(providerURL, BigInt(blockNumber), {
        common: new common_1.Common({ chain, hardfork })
    });
    const headerRlp = `0x${Buffer.from(block.header.serialize()).toString('hex')}`;
    const headerInts = ints_sequence_1.IntsSequence.fromBytes((0, bytes_1.hexToBytes)(headerRlp));
    return {
        blockNumber,
        headerInts: __1.encoding.reverseByteOrder(headerInts.values),
    };
};
exports.getProcessBlockInputsForBlockNumber = getProcessBlockInputsForBlockNumber;
